import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { format, parseISO } from "date-fns";

import { RTPDeliveryChannel } from "@APP/types";
import { RTP_DELIVERY_CHANNEL_LABEL } from "@APP/constants";

type DeliveryMethodAuditProps = {
  history: { date: string; method: RTPDeliveryChannel }[];
  channel: string;
  onClose: () => void;
};

const DeliveryMethodAudit = ({ history, channel, onClose }: DeliveryMethodAuditProps) => {
  const sortedHistory = [...history].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h4">Audit with Delivery Method & Date.</Typography>
      </DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant="body1">
            <strong>Delivery Method:</strong> {channel}
          </Typography>
        </Box>
        {sortedHistory.length === 0 ? (
          <Box mt={2}>
            <Typography variant="body2" color="textSecondary">
              Delivery history not available.
            </Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Date</strong>
                </TableCell>
                <TableCell>
                  <strong>Delivery Method</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedHistory.map((record, index) => (
                <TableRow key={index}>
                  <TableCell>{format(parseISO(record.date), "dd/MM/yyyy HH:mm:ss a")}</TableCell>
                  <TableCell>{RTP_DELIVERY_CHANNEL_LABEL[record.method]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeliveryMethodAudit;
